import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play--yellow",
  "use": "icon-play--yellow-usage",
  "viewBox": "0 0 45 45",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 45 45\" id=\"icon-play--yellow\"><circle cx=\"22.5\" cy=\"22.5\" r=\"22.5\" fill=\"#FFB82E\" /><path d=\"M29.634 23.049 18.11 29.702V16.395l11.524 6.654Z\" fill=\"#262626\" /><circle cx=\"22.5\" cy=\"22.5\" r=\"17\" stroke=\"#262626\" stroke-width=\"3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol